import React from 'react';
import './skills.css';
import { skillGroups } from '../../data/skills';

const Skills = () => (
  <section id="skills">
    <div className="container">
      <div className="section__head reveal">
        <span className="section__eyebrow">04 — Skills</span>
        <div className="section__title">
          <h2>The stack behind the systems</h2>
        </div>
        <p className="section__lead">
          Everything listed here is something I have used to ship or operate production software —
          not a tutorial checklist.
        </p>
      </div>

      <div className="skills__grid">
        {skillGroups.map((group, i) => (
          <article
            key={group.id}
            className={`card skills__card ${group.featured ? 'is-featured' : ''} reveal`}
            style={{ transitionDelay: `${(i % 3) * 80}ms` }}
          >
            <header className="skills__card-head">
              <h3>{group.title}</h3>
              <span className="skills__count mono">{group.skills.length}</span>
            </header>

            <p className="skills__blurb">{group.blurb}</p>

            <ul className="skills__list">
              {group.skills.map((skill) => (
                <li key={skill} className="tag">
                  {skill}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
